import { useTranslation } from "react-i18next";
import { modalControl } from "util/commAction";
import PromCdModalInner from "./promcdModal/promCdModal";
import { BookInfProvider } from "components/context/bookInfContext";
import Button from "components/button/default";
import "./roominf.scss";

export default function PromCd() {
  const { t } = useTranslation();

  return (
    <div className="prom-cd">
      <Button
        text={t("btn_hm_app_prmCd")}
        styels="w-48"
        onClick={() => {
          modalControl({
            isOpen: true,
            btnTxt: t("btn_hm_md_app_code"),
            styles: "max-w-[386px]",
            chckBtn: false,
            inner: (
              <BookInfProvider>
                <PromCdModalInner />
              </BookInfProvider>
            ),
          });
        }}
      />
    </div>
  );
}
